/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { is, mapObjIndexed, prop } from 'ramda'
import React from 'react'

import { getSmartSize } from '../../utils/helpers/styles'
import { useColorableSpaceStyle } from '../../utils/styles/colorableSpace'
import { useDisabledStyle } from '../../utils/styles/disabled'
import LoadingWrapper from '../helpers/LoadingWrapper'
import Text from '../presentation/Text'

export const SIZES = {
  xxxsmall: { width: 0.8, height: 0.8, fontSize: 'xxxsmall', paddingH: 0.1 },
  xxsmall: { width: 1, height: 1, fontSize: 'xxxsmall' },
  xsmall: { width: 3, height: 1.2, fontSize: 'xxsmall' },
  small: { width: 4, height: 1.6, fontSize: 'xsmall' },
  normal: { width: 6, height: 1.8, fontSize: 'small' },
  large: { width: 6, height: 2, fontSize: 'p' },
  xlarge: { width: 7, height: 2.6, fontSize: 'p' }
}

const Button = ({ children, size, onClick, type, loading, ...props }) => {
  size = size || 'normal'
  const fontSizeValue = getSmartSize(size, mapObjIndexed(prop('fontSize'), SIZES), 'p')
  const [colorableSpaceStyle, fontColor] = useColorableSpaceStyle({ size, sizes: SIZES, ...props })
  const style = css`
    ${colorableSpaceStyle}
    ${useDisabledStyle(props)}
    cursor: pointer;
  `

  children = is(String, children) ? (
    <Text size={fontSizeValue} align="center" color={fontColor} bold>
      {children}
    </Text>
  ) : (
    children
  )

  return (
    <button
      className="button"
      css={style}
      onClick={!loading && !props.disabled ? onClick : undefined}
      type={type || 'button'}
    >
      <LoadingWrapper loading={loading} color={fontColor} size="normal">
        {children}
      </LoadingWrapper>
    </button>
  )
}

export default Button
